module.exports = __webpack_public_path__ + "static/img/footer-dy.1841ca4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer-dy.png
// module id = k5Ju
// module chunks = 1